<template>
  <div class="address_big">
    <div style="width:1260px;margin:0 auto">
      <div class="address_top">
        <div class="title">收货地址</div>
        <div class="address_text">
          <div class="left">
            <div v-if="add_show">
              <div class="boxx">
                <div class="boxx1">
                  <span style="letter-spacing:4px">收货人：</span>
                  <el-input style="width:260px;" maxlength="20" v-model="datas.consignee"></el-input>
                </div>
                <div class="boxx1">
                  <span>手机号码：</span>
                  <el-input
                    style="width:260px;"
                    maxlength="11"
                    @blur="bindphone"
                    v-model="datas.mobile"
                  ></el-input>
                </div>
              </div>
              <div class="boxx">
                <span>所在地区：</span>
                <div style="width:653px;">
                  <el-select
                    style="width:152px;margin-right:15px;"
                    v-model="city_s"
                    @change="bindchanges"
                    placeholder="请选择省"
                  >
                    <el-option
                      v-for="item in dq_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    style="width:152px;margin-right:15px;"
                    v-model="city_c"
                    @change="bindchangeq"
                    placeholder="请选择市"
                  >
                    <el-option
                      v-for="item in city_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    style="width:152px;margin-right:15px;"
                    v-model="city_q"
                    @change="bindchangey"
                    placeholder="请选择区"
                  >
                    <el-option
                      v-for="item in qy_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="city_x"
                    v-if="xz_list.length>0"
                    @change="bindchangex"
                    placeholder="请选择乡镇"
                    style="width:152px;margin-right:0"
                  >
                    <el-option
                      v-for="item in xz_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="boxx11">
                <span>详细地址：</span>
                <el-input
                  type="textarea"
                  placeholder="请输入详细地址，如道路、门牌号、小区、楼栋号、单元等"
                  v-model="datas.detail"
                  maxlength="110"
                  style="width:652px;"
                ></el-input>
              </div>
              <!-- 定位地址 -->
              <!-- <el-form ref="form" :model="datas" label-width="78px">
              <el-form-item label="详细地址 : " >
                <el-col :span="14" style="margin-left:8px;">
                  <el-form-item prop="address">
                    <el-select
                      class="m-r-12"
                      v-model="datas.details"
                      value-key="uid"
                      filterable
                      remote
                      clearable
                      reserve-keyword
                      placeholder="请输入地址关键词（选择所在地区精确搜索）"
                      :remote-method="getSearchAddress"
                      :loading="selectLoading"
                      @change="onPointChange"
                      style="width: 100%"
                    >
                      <el-option v-for="item in searchResult" :key="item.uid" :value="item" :label="item.name">
                        <div class="onelist-hidden">
                          {{ item.name }} <span v-if="item.address">({{ item.address }})</span>
                        </div>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" :offset="1">
                  <el-form-item prop="doorplate">
                    <el-input v-model="datas.doorplate" placeholder="请输入门牌号"></el-input>
                  </el-form-item>
                </el-col>
              </el-form-item>
              </el-form> -->
            </div>
            <div v-else>
              <div style="margin-top:30px;">
                <span style="color:#909199;letter-spacing:4px">收货人：</span>
                <span>{{show_address.consignee}}</span>
                <span class="xiugai" @click="bindxiugai">修改</span>
              </div>
              <div style="margin:20px 0">
                <span style="color:#909199">联系方式：</span>
                <span>{{show_address.mobile}}</span>
              </div>
              <div>
                <span style="color:#909199">收货地址：</span>
                <span>{{show_address.province}}{{show_address.city}}{{show_address.district}}{{show_address.town}}{{show_address.detail}}</span>
                <!-- <span>{{show_address.province}}{{show_address.city}}{{show_address.district}}{{show_address.town}}{{show_address.detail}}{{show_address.doorplate}}</span> -->
              </div>
            </div>
          </div>
          <div class="right">
            <div v-if="add_show">
              <div style="margin-top:50px;margin-bottom:20px;">
                <el-checkbox v-model="isDefault">设为默认</el-checkbox>
              </div>

              <div class="aniu">
                <span class="ljdh" @click="bc_address">地址确认</span>
                <span v-if="address_list.length>0" class="ljdhs" @click="bindqxqx">取消</span>
              </div>
            </div>
            <div v-else class="add_rights">
              <p
                class="new_adds"
                style="color:#3395F5;margin-top:30px;"
                @click="tpVisible=true"
              >切换地址</p>
              <span class="new_add" @click="bindxj">新建地址</span>
            </div>
          </div>
        </div>
      </div>
      <!-- //选择卡
       <div class="address_bottom sps">
       
        <div class="lists">
          <div class="list_top">
            <span style="width:700px;">选择支付方式</span>
          </div>
          <div class=" ">
            <div class="list_bottom k_big">
              <div class="k_box" :class="item.show?'k_boxs':''" v-for='(item,index) in card_list' :key='index' style="width:280px;height:120px;border:1px solid #E6E6E6">
                <div><Checkbox v-model="item.show"></Checkbox></div>
                <div style="width:88%;">
                  <p style="font-size:18px;color:#0A1132;font-weight:600">{{item.ticketCardNo}}</p>
                  <div class="k_bl">
                    <span style="color:#5B5D66">{{item.productName}}</span>
                    <div style="display:flex;align-items:center;color:#FB3F45;font-weight:600">
                      <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                      <img src="../../assets/img/pindou.png" v-if="!user.festival||!user.festival.priceSymbol" alt="" style="width:16px;height:16px;">
                      <span style="color:#FB3F45">{{item.balance/100}}</span>
                      <span style="color:#FB3F45" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
                    </div>
                  </div>
                  <p style="color:#5B5D66;font-size:12px;">有效期：{{item.cardDate}}</p>
                </div>
              </div>
              
            </div>
            <div class="box_x">
              <div class="add_k" @click="add_k_show=true"><span>+</span><span>添加券</span></div>
              <span style="color:#666666;font-size:14px;">显示更多></span>
            </div>
            
          </div>
        </div>
      </div> -->


      <div class="address_bottom sps">
        <p
          style="font-size:18px;color:#0A1132;margin-bottom:10px"
          v-if="gift_details"
        >{{gift_details.festivalPackage.name}}</p>
        <div
          class="lists"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <div class="list_top">
            <span style="width:700px;">商品信息</span>
            <!-- <span class="rights" style="text-align:left">规格</span> -->
            <span class="rights">数量</span>
          </div>
          <div class="list_bottom">
            <div v-for="(items,indexs) in gift_list" :key="indexs" class="l_boxs">
              <div class="l_box" v-for="(item,index) in items.pinucOrderItemList" :key="index">
                <div style="display: flex;align-items: center;width:700px;">
                  <img
                    style="height:80px;width:80px;margin-right:16px"
                    :src="item.itemSkuJson.baseImage"
                  />
                  <div>
                    <p>{{item.skuName}}</p>
                    <div style="margin-top:5px;">
                      <span
                        style="margin-right:10px;color:font-size:12px;color:#999999"
                        v-for="(itemm,indexm) in item.attrJson"
                        :key="indexm"
                      >{{itemm.name}}：{{itemm.optionValue}}</span>
                    </div>
                    <div style="margin-top:5px;">
                      <span
                        style="margin-right:10px;color:font-size:12px;color:#999999"
                        v-for="(itemm,indexm) in item.subGoods"
                        :key="indexm"
                      >{{itemm.name}}：{{itemm.sub_name}}</span>
                    </div>
                    <div style="color:#FC2920;font-size:12px;" v-if='item.stockStae==0'>库存不足</div>
                  </div>
                </div>
                <!-- <div class="rights" >
					<p
                        style="margin-right:10px;color:font-size:12px;color:#999999;text-align:left;"
                        v-for="(itemm,indexm) in item.attrJson"
                        :key="indexm"
                      >{{itemm.name}}：{{itemm.optionValue}}</p>
				</div> -->
                <span class="rights">{{item.purchaseNumber}}</span>
                <div @click="bindtime(item)" v-if='item.time_show==1' style="font-size:14px;color:rgb(51, 149, 245);margin-left:50px;cursor: pointer;">{{item.xz_time?item.xz_time:'选择配送时间'}}</div>
                <div @click="deliveryClick(item)" v-if='item.date_show'  style="font-size:14px;color:rgb(51, 149, 245);margin-left:50px;cursor: pointer;">{{getDelivery(item.itemSkuJson).isSelect ? getDelivery(item.itemSkuJson).timeText : getDelivery(item.itemSkuJson).placehelpText}}<img src="../../assets/images/gg.png" v-if="getDelivery(item.itemSkuJson).isSelect" @click.stop="clearDelivery(item.itemSkuJson)" class="clear_date"/> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <p v-if="!address_show"
              style="color:#FD2F51;margin-bottom:10px;text-align:right;margin-top:10px;"
            >{{show_address?ts_show:'暂无收货地址'}}</p>
      <div style="display:flex;justify-content:space-between;margin-top:32px;">
          <div style="display:flex;justify-content:space-between;">
            <span>订单备注：</span>
            <textarea name="" id="" cols="100" rows="2" maxlength="100" v-model="remark" style="padding:0 12px;height:72px;border-color:#E6E6E6;margin-left:10px;" placeholder="选填，请填写商品备注"></textarea>
          </div>
          <div style="text-align:right;">
            
            <!-- <div v-if="user&&user.festival&&user.festival.type==2" style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px"> -->
            <div v-if="user&&user.festival&&user.festival.type==2&&user.festival.id!=$store.state.hidePriceid" style="margin-bottom:16px">
              <span></span>
              <div class="sale_price" style="padding-left:10px" >
                <span style="color:#5B5D66;">礼包金额：</span>
                <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                <img style="width:16px;height:16px;background:none;" v-if="!user.festival||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
                <span style="font-size:16px;color:#FD5430;font-weight:600" v-if="!cart_show&&gift_details.festivalPackage">{{gift_details.festivalPackage.standardPrice/100}}</span>
                <span style="font-size:16px;color:#FD5430;font-weight:600" v-if="cart_show">{{all_price}}</span>
                <span style="font-size:16px;color:#FD5430;font-weight:600" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
              </div>
              <div class="sale_price" style="padding-left:10px" >
                <span style="color:#5B5D66;">运费金额：</span>
                <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                <img style="width:16px;height:16px;background:none;" v-if="!user.festival||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
                <span style="font-size:16px;color:#FD5430;font-weight:600">{{freight}}</span>
                <span style="font-size:16px;color:#FD5430;font-weight:600" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
              </div>
              <div class="sale_price" style="padding-left:10px" >
                <span style="color:#5B5D66;">应付金额：</span>
                <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                <img style="width:16px;height:16px;background:none;" v-if="!user.festival||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
                <span style="font-size:16px;color:#FD5430;font-weight:600" v-if="!cart_show&&gift_details.festivalPackage">{{gift_details.festivalPackage.standardPrice/100+freight}}</span>
                <span style="font-size:16px;color:#FD5430;font-weight:600" v-if="cart_show">{{all_price+freight}}</span>
                <span style="font-size:16px;color:#FD5430;font-weight:600" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
              </div>
            </div>
            <span
              v-if="address_show&&!loadingg&&show_address&&kc_num==0"
              @click="bindconfirm"
              style="cursor: pointer;height:42px;width:144px;background:#F3A251;color:white;display: inline-block;line-height:42px;text-align:center"
            >{{user&&user.festival&&user.festival.type==2?'创建订单':'立即兑换'}}</span>
            <span
              v-loading="loadingg"
              element-loading-text
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              v-else
              class="binddh"
              style="cursor: pointer;height:42px;width:144px;background:#F3A251;color:white;display: inline-block;line-height:42px;text-align:center"
            >{{user&&user.festival&&user.festival.type==2?'创建订单':'立即兑换'}}</span>
          </div>
         
      </div>
      
    </div>
    <el-dialog title="选择收货地址" :visible.sync="tpVisible" width="620px" center>
      <div style="height:350px;max-height:550px;overflow: auto;padding:0 20px">
        <div
          @click="select_address(item.uid)"
          class="dz_box"
          :class="item.uid==add_index?'dz_top_active':''"
          v-for="item in address_list"
          :key="item.uid"
        >
          <div class="dz_top">
            <div>
              <span style="font-size:16px;color:#0A1132">{{item.consignee}}</span>
              <span style="font-size:16px;color:#0A1132;margin-left:32px">{{item.mobile}}</span>
              <span
                style="color:#3395F5;border:1px solid #3395F5;margin-left:10px;display:inle-block;padding:0 5px"
                v-if="item.defaultAddress"
              >默认</span>
            </div>
            <span style="color:#5B5D66" @click.stop="binddelete(item.uid)">删除</span>
          </div>
          <p
            style="margin-top:14px;color:#909199;width:100%;text-align:left"
          >{{item.province}}{{item.city}}{{item.district}}{{item.town}}{{item.detail}}</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button
          style="height：42px;width:144px;background:#F3A251;color:white;"
          @click="bindselect"
        >确定</el-button>
        <el-button style="height：42px;width:144px;" @click="tpVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择配送时间" :visible.sync="sjVisible" width="900px" center>
      <div style="height:350px;max-height:550px;overflow: auto;padding:24px">
        <div class="xzrq">
          <span style="color:#5B5D66;width:60px;display:inline-block">选择日期</span>
          <div style="padding-left:24px;width:91%">
            <span class="sj_box" @click="bindxz_time(item.time)" :class="item.time==time_show?'t_active':''" v-for='(item,index) in time_list' :key='index'>{{item.name}}</span>
          
           
          </div>
        </div>
        <div class="xzrq" style="margin-top:30px;">
          <span style="color:#5B5D66;">选择时间</span>
          <div style="padding-left:24px;">
            <span class="sj_box" :class="(time_show+' '+item)==xz_show_time?'t_active':''" v-for='(item,index) in c_time_list' :key='index' @click="binddj_time(item)">{{item}}</span>
            <div v-if="!qhjz_show&&c_time_list&&c_time_list.length==0">不支持配送</div>
						<div v-if="qhjz_show" style="text-align:center;margin-top:100rpx;border:none">
              <img style="width:60px;height:60px" src="../../assets/img/timgs.gif" />
						</div>
           
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button
          style="height：42px;width:144px;background:#F3A251;color:white;"
          @click="bindselect_time"
        >确定</el-button>
        <el-button style="height：42px;width:144px;" @click="sjVisible = false">取消</el-button>
      </div>
    </el-dialog>
	 <el-dialog title="选择期望发货日期" :visible.sync="deliveryTimeShow" width="900px" center>
      <div style="height:350px;max-height:550px;overflow: auto;padding:24px">
        <div class="xzrq">
          <span style="color:#5B5D66;width:60px;display:inline-block">选择日期</span>
          <div style="padding-left:24px;width:91%">
            <span class="sj_box" @click="changeTimeDate(item)" :class="item==filterTime?'t_active':''" v-for='(item,index) in deliveryItem.dateSkuList' :key='index'>{{item}}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button
          style="height：42px;width:144px;background:#F3A251;color:white;"
          @click="sureDelivery"
        >确定</el-button>
        <el-button style="height：42px;width:144px;" @click="deliveryTimeShowClose">取消</el-button>
      </div>
    </el-dialog>
    <div class="tk_box" v-if="add_k_show">
			<p class="bj"></p>
			<div class="add_kj">
				<div class="add_kj_top">
					<span>添加卡劵</span>
				</div>
				<div class="add_kj_nav">
					<span :class="add_nav==1?'add_nav_active':''" @click='bindnav(1)'>品诺券</span>
					<span style="margin-left:24px;" :class="add_nav==3?'add_nav_active':''" @click='bindnav(3)'>电子劵</span>
					<!-- <span :class="add_nav==2?'add_nav_active':''" @click='bindnav(2)'>已绑定卡</span> -->
				</div>
				<div class='add_kj_center' v-if="add_nav==1">
					<div class="center_box">
						<span>卡号：</span>
						<input type="" name="" id="" v-model="k_number" value="" placeholder="请输入您的卡号"/>
					</div>
					<div class="center_box">
						<span>密码：</span>
						<input type="password" name="" id="" v-model="k_password" value="" placeholder="请输入您的密码"/>
					</div>
				</div>
				<div class='add_kj_center' v-if="add_nav==3">
					<div class="center_box" style="padding:0 10px;">
						<span>电子劵：</span>
						<input style="width:300px" type="" name="" id="" v-model="kj_number" value="" placeholder="请输入电子劵号"/>
					</div>
				</div>
				<div class='add_kj_center1' v-if="add_nav==2">
					<div class="ybk_box" v-for="(item,index) in list" :key='index'>
						<span>{{item.ticketCardNo}}</span>
						<div @click="bindxk(item.ticketCardNo)">
						</div>
					</div>
					<p v-if="list==''" style="margin-top:20px">暂无已绑定卡</p>
				</div>
				<div class="kj_bottom">
					<div>
						<span @click="bindadd">添加</span>
            <span @click="add_k_show=false">取消</span>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import nav from '../nav'
import getCurrentCityName from '../../js/map'
import links from '../../js/link_parameters'
import wechatAuth from '../../wechatAuth'
import { Message, Loading } from 'element-ui'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Vue from 'vue'
import $ from 'jquery'
import axios from 'axios'
import Tables from '../../components/tables/tables'
import echarts from 'echarts'
import { formatDate, formatTimeToStr, deepCopy } from '../../js/data'
export default {
  name: 'index',
  components: {
    Tables
  },
  data() {
    var vm = this
    return {
      list: '',
      kj_number: '',
      k_number: '',
      k_password: '',
      add_k_show: false,
      add_nav: 1,
      single: '',
      remark: '',
      c_time_list: [],
      qhjz_show: false,
      sjVisible: false,
      gift_list: '',
      datas: {},
      add_show: true,
      mr_checked: false,
      gift_details: '',
      tpVisible: false,
      gift_id: this.$route.query.id ? this.$route.query.id : '',
      address_id: this.$route.query.address_id ? this.$route.query.address_id : '',
      cart_show: this.$route.query.cart_show ? this.$route.query.cart_show : false,
      address_list: '',
      show_address: '',
      add_index: null,
      loadingg: false,
      isDefault: false,
      loading: false,
      datas: {
        consignee: '',
        mobile: '',
        province: '',
        city: '',
        district: '',
        town: '',
        provinceId: '',
        cityId: '',
        districtId: '',
        townId: '',
        detail: '',
        details: '',
        // doorplate:'',
        isDefault: false
      },
      dq_list: '', //地区
      city_s: '',
      city_list: '',
      city_c: '',
      qy_list: '',
      xz_list: '',
      city_q: '',
      city_x: '',
      province: {},
      city: {},
      district: {},
      town: {},
      zq_show: {}, //选中的专区
      address_show: true,
      ts_show: '',
      time_list: [],
      time_show: '',
      id_show: '',
      xz_show_time: '',
      user: '',
      all_price: 0,
      cart_list: [],
      card_list: [],
      freight: 0,
      kc_num: 0,
      selectLoading: true,
      searchResult: [],
      // 日期发货时间选择
      filterTime: '',
      deliveryTimeShow: false, //日期发货时间选择
      deliveryItem: {}, //当前发货日期商品
      deliveryDataMap: new Map(), //发货日期数据集合
      deliveryMapCount: 0
    }
  },
  computed: {
    //获取当前日期选择数据
    getCurrentDelivery() {
      return () => {
        let id = this.deliveryItem?.itemSkuJson?.id || ''
        let dateSkuList = this.deliveryItem?.dateSkuList
        if (id) {
          if (this.deliveryDataMap.has(id)) {
            this.filterTime = this.deliveryDataMap.get(id)
            return this.deliveryDataMap.get(id)
          }
        }
        return dateSkuList[0]
      }
    },
    //获取日期
    getDelivery() {
      return (item) => {
        var x = this.deliveryMapCount
        return {
          placehelpText: '请选择期望发货日期',
          isSelect: !!this.deliveryDataMap.get(item.id),
          timeText: this.deliveryDataMap.get(item.id)
        }
      }
    },
    currentDate() {
      let nowTime = new Date(),
        year = nowTime.getFullYear(),
        month = nowTime.getMonth() + 1,
        date = nowTime.getDate()
      return `${year}-${month < 10 ? '0' + month : month}-${date < 10 ? '0' + date : date}`
    }
  },
  created() {},
  mounted() {
    var user = sessionStorage.getItem('user')
    if (user) {
      this.user = JSON.parse(user)
    } else {
      this.$router.push({ path: '/login' })
    }
    console.log(JSON.parse(user))
    this.getUser(true)
    this.getaddress()
    this.queryRegions()
    this.getOneMonthDateList()
  },
  methods: {
    clearDelivery({ id }) {
      if (this.deliveryDataMap.has(id)) {
        this.deliveryDataMap.delete(id)
        this.deliveryMapCount += 1
      }
      console.log('this.deliveryDataMap', this.deliveryDataMap)
    },
    //获取发货日期参数组装
    getDateDeliveryQuery() {
      if (this.deliveryDataMap.size) {
        let expectedShippingTimes = []
        for (let key of this.deliveryDataMap.keys()) {
          expectedShippingTimes.push(`${key}_${this.deliveryDataMap.get(key)}`)
        }
        return expectedShippingTimes.join(',')
      } else {
        return ''
      }
    },
    //点击发货日期
    deliveryClick(item) {
      console.log(item)
      this.deliveryItem = item
      this.filterTime = this.getCurrentDelivery(this.deliveryItem)
      this.deliveryTimeShow = true
    },
    //确定发货日期
    sureDelivery() {
      let { id } = this.deliveryItem.itemSkuJson
      // if(this.deliveryDataMap.has(supplierId)){
      this.deliveryDataMap.set(id, this.filterTime ? this.filterTime : this.getCurrentDelivery(this.deliveryItem))
      this.deliveryMapCount += 1
      // }
      console.log(this.deliveryDataMap, 'this.deliveryDataMap')
      this.deliveryTimeShowClose()
    },
    //关闭时间发货时间选择
    deliveryTimeShowClose() {
      this.deliveryItem = {}
      this.filterTime = ''
      this.deliveryTimeShow = false
    },
    //日期切换
    changeTimeDate(value) {
      console.log(value)
      this.filterTime = value
      // this.getPerformList()
      // this.popShow = false
    },
    //获取选择地址详情
    getPointDetail(location) {
      console.log('获取选择地址详情', location)
      let { lat, lng } = location
      return this.$jsonp('http://api.map.baidu.com/reverse_geocoding/v3/', {
        location: `${lat},${lng}`,
        ak: '8c68c81ef784d598971b790b8af3b45d',
        output: 'json',
        extensions_poi: 0,
        extensions_town: true
      })
    },
    getPointList(searchValue) {
      let { province, city, district, town } = this.datas
      return this.$jsonp('http://api.map.baidu.com/place/v2/search', {
        query: searchValue,
        ak: '8c68c81ef784d598971b790b8af3b45d',
        region: this.city.name ? this.city.name : this.province.name ? this.province.name : '北京',
        // region: `${province}${city}${district}${town}`,
        output: 'json',
        page_size: 20,
        city_limit: true,
        extensions_adcode: true
      })
    },
    async onPointChange(data) {
      if (!data) {
        this.searchResult = []
        return
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      let { status, result } = await this.getPointDetail(data.location)
      if (status === 0) {
        console.log('result', result)
        console.log('选择地区', data)
        this.datas.detail = data.name
        let adCode = result.addressComponent.town_code
        let pointTown = result.addressComponent.town
        let res = await this.$server.queryRegionsByAdCode({ adCode }, headers)
        let {
          default: { province, city, district, default: town }
        } = res.data
        // let syncRegions = { province: null, city: null, district: null, town: null } //同步行政区划数据
        // let queryRegions = { province, city, district, town } //匹配后的行政区划
        // let selectData = deepCopy(this.datas) //当前选中的行政区划
        // console.log('selectData', selectData)
        console.log('获取code数据', res)
        console.log('选择的省市区', this.datas)
        if (this.datas.town && this.datas.provinceId == province.id && this.datas.cityId == city.id && this.datas.districtId == district.id) {
          return
        } else {
          this.datas.provinceId = province.id
          this.datas.cityId = city.id
          this.datas.districtId = district.id
          this.datas.townId = town ? town.id : 0
          this.datas.province = province.name
          this.datas.city = city.name
          this.datas.district = district.name
          this.datas.town = town ? town.name : ''
          if (!this.datas.townId) {
            this.bindchangey(district.id)
          }
          ///////////////////////////////////////////////////////////////
          this.city_s = province.id
          this.city_c = city.id
          this.city_q = district.id
          this.city_x = town ? town.id : ''
          var data = {
            parentId: province.id
          }
          var headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: this.user.token
          }
          this.$server.querydq(data, headers).then((res) => {
            console.log(res)
            var list = res.data.default
            this.city_list = list
            //						this.city_c= list[0]
          })
          var data = {
            parentId: city.id
          }
          var headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: this.user.token
          }
          this.$server.querydq(data, headers).then((res) => {
            console.log(res)
            var list = res.data.default
            this.qy_list = list
            //						this.city_c= list[0]
          })
          var data = {
            parentId: district.id
          }
          var headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: this.user.token
          }
          this.$server.querydq(data, headers).then((res) => {
            console.log(res)
            var list = res.data.default
            this.xz_list = list
            //						this.city_c= list[0]
          })
          //////////////////////////////////////////////////////////////////////
        }
      }
    },
    /**
     * 查询省市区数据
     * @param {String} locationType 位置类型，1：省，2：市，3：区
     */
    queryLocationData(parentId = 0) {
      return new Promise((resolve, reject) => {
        var headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.user.token
        }
        this.$server.querydq({ parentId }, headers).then((res) => {
          console.log(res)
          let locationData = res.default
          resolve(locationData)
        })
      })
    },
    async getSearchAddress(searchValue) {
      if (searchValue) {
        console.log(searchValue)
        let _this = this
        this.selectLoading = true
        let { results: pointList } = await this.getPointList(searchValue)
        this.searchResult = pointList
        this.selectLoading = false
      }
    },
    // //////////////////////////////////////////////
    getUser(e) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.getCardUserBalance({}, headers).then((res) => {
        console.log(res)
        if (res.code == 0) {
          var user = this.user
          this.$store.state.validTimes = res.data.default.validTimes
          this.$store.state.balance = res.data.default.balance
          sessionStorage.setItem('user', JSON.stringify(user))
          if (e) {
            res.data.default.show = true
            this.card_list.push(res.data.default)
          }
        }
        console.log('卡list', this.card_list)
      })
    },
    bindadd() {
      console.log('添加')
    },
    bindnav(e) {
      this.add_nav = e
    },
    bindxz_time(e) {
      this.time_show = e
      this.bindgettime()
    },
    binddj_time(e) {
      if (e == '不支持配送') {
        return
      }
      this.xz_show_time = this.time_show + ' ' + e
    },
    bindselect_time() {
      var gift_list = this.gift_list
      gift_list.forEach((item) => {
        item.pinucOrderItemList.forEach((item1) => {
          if (item1.itemSkuJson.id == this.id_show) {
            console.log(item1)
            item1.xz_time = this.xz_show_time
          }
        })
      })
      this.sjVisible = false
      console.log(gift_list)
    },
    getOneMonthDateList() {
      let daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
      let currentDate = new Date()
      currentDate.setMonth(currentDate.getMonth() + 1)
      let strYear = currentDate.getFullYear()
      let strDay = currentDate.getDate()
      let strMonth = currentDate.getMonth() + 1

      if ((strYear % 4 === 0) & (strYear % 100 !== 0) || strYear % 400 === 0) {
        daysInMonth[2] = 29
      }

      if (strMonth - 1 === 0) {
        strYear -= 1
        strMonth = 12
      } else {
        strMonth -= 1
      }

      strDay = Math.min(strDay, daysInMonth[strMonth])

      if (strMonth < 10) {
        strMonth = '0' + strMonth
      }

      if (strDay < 10) {
        strDay = '0' + strDay
      }

      let dateStr = strYear + '-' + strMonth + '-' + strDay
      const dateList = []
      let startDate = new Date(dateStr)
      var ws = startDate.getDay()
      var weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][ws]
      var jintian = {
        name: strMonth + '月' + strDay + '日 ' + weeks,
        time: dateStr
      }
      dateList.push(jintian)

      while (true) {
        startDate.setDate(startDate.getDate() + 1)
        var w = startDate.getDay()
        var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][w]
        if (startDate.getTime() < currentDate.getTime()) {
          var y = startDate.getMonth() + 1
          var r = startDate.getMonth() - 1
          var yy = y < 10 ? '0' + y : y
          if (startDate.getDate() < 10) {
            // startDate.getFullYear() 获取年，此处没加上年份
            if (startDate.getMonth() < 10) {
              var time = {
                name: yy + '月0' + startDate.getDate() + '日 ' + week,
                time: startDate.getFullYear() + '-0' + y + '-0' + startDate.getDate()
              }
            } else {
              var time = {
                name: yy + '月0' + startDate.getDate() + '日 ' + week,
                time: startDate.getFullYear() + '-' + y + '-0' + startDate.getDate()
              }
            }

            dateList.push(time)
          } else {
            if (y < 10) {
              var time = {
                name: yy + '月' + startDate.getDate() + '日 ' + week,
                time: startDate.getFullYear() + '-0' + y + '-' + startDate.getDate()
              }
            } else {
              var time = {
                name: yy + '月' + startDate.getDate() + '日 ' + week,
                time: startDate.getFullYear() + '-' + y + '-' + startDate.getDate()
              }
            }

            dateList.push(time)
          }
        } else {
          break
        }
      } // return dateList

      this.time_list = dateList
      this.time_show = dateStr
    },
    bindgettime(e) {
      ;(this.c_time_list = ''), (this.qhjz_show = true)
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }

      if (
        this.show_address.province == '北京' ||
        this.show_address.province == '天津' ||
        this.show_address.province == '上海' ||
        this.show_address.province == '重庆'
      ) {
        var iid = this.show_address.provinceId
      } else {
        var iid = this.show_address.cityId
      }

      var data = {
        skuId: this.id_show,
        cityId: iid,
        date: this.time_show
      }
      this.$server.getItemDeliveryTime(data, headers).then((res) => {
        console.log(res)

        if (res.code == 0) {
          ;(this.c_time_list = res.data.default[0].data), (this.qhjz_show = false)
        } else {
          this.qhjz_show = false
        }
      })
    },
    bindtime(e) {
      console.log(e)
      this.sjVisible = true
      this.id_show = e.itemSkuJson.id
      this.bindgettime()
    },
    bindphone(e) {
      var value = this.datas.mobile
      console.log(this.datas.mobile)
      if (!/^[1](([3][0-9])|([4][0-9])|([5][0-9])|([6][0-9])|([7][0-9])|([8][0-9])|([9][0-9]))[0-9]{8}$/.test(value)) {
        this.datas.mobile = ''
        this.$message({
          message: '请输入正确的手机号码',
          type: 'warning'
        })
      }
    },
    // bindname(e){
    // 	console.log(e)
    // },
    bindqxqx() {
      this.add_show = false
      this.datas.detail = this.datas.log_details
      this.city_s = ''
      this.city_c = ''
      this.city_q = ''
      this.bindcz()
    },
    // validTimes
    bindconfirm() {
      if (
        (this.user.festival.type == 2 && this.$store.state.balance > 0) ||
        (this.user.festival.type == 1 && this.$store.state.validTimes > 0) ||
        this.user.festival.id == this.$store.state.payment0
      ) {
        // if(this.$store.state.balance>0){
        if (this.cart_show) {
          if (this.user && this.user.festival && this.user.festival.type == 2) {
            this.binddhs_cart()
          } else {
            this.binddhs()
          }
        } else {
          if (this.user && this.user.festival && this.user.festival.type == 2) {
            this.bindcreatds()
          } else {
            this.binddhs()
          }
        }
      } else {
        this.$message({
          message: '账户余额为0不能兑换礼包',
          type: 'warning'
        })
      }
    },
    bindcreatds() {
      var lb_detail = this.gift_details
      var gift_list = this.gift_list
      console.log('礼包信息', this.gift_details)
      console.log('礼包信息s', gift_list)
      var list = this.gift_details.spuList
      var ids = ''
      var f_ids = ''
      var deliveryTimes = ''
      var text = ''
      var tipText = ''
      var dateText = ''
      list.forEach((item, index) => {
        console.log(item)
        item.itemSkus.forEach((item1) => {
          gift_list.forEach((item2) => {
            item2.pinucOrderItemList.forEach((item3) => {
              if (item1.id == item3.skuId) {
                item1.xz_time = item3.xz_time
                console.log('选择的时间', item3.xz_time)
                if (item3.xz_time) {
                  deliveryTimes += item3.xz_time + ','
                } else {
                  deliveryTimes += ' ' + ','
                }
                if (item3.time_show == 1 && (item3.xz_time == '' || !item3.xz_time)) {
                  text += item3.skuName + ','
                }
                if (item3.time_show == 2) {
                  tipText += item3.skuName + ','
                }
                if (item3.date_show && !this.deliveryDataMap.get(item3.skuId)) {
                  dateText += item3.skuName + ','
                }
              }
            })
          })
          if (item.show_skuid == 0) {
            ids += item1.id + '_' + lb_detail.spuNoList[index] + ','
          } else {
            if (item.show_skuid == item1.id) {
              ids += item1.id + '_' + lb_detail.spuNoList[index] + ','
            }
          }
        })
        if (item.subGoodss) {
          var subb = ''
          item.subGoodss.forEach((item1) => {
            if (item1.indexx >= 0 && item1.indexx != null && item1.sub_goods && item1.sub_goods.length > 0) {
              subb += item1.sub_goods[item1.indexx].id + '_'
            }
          })
          console.log(subb)
          subb = subb.substring(0, subb.length - 1)
          f_ids += subb + ','
        } else {
          f_ids += ' ' + ','
        }
      })
      var remarks = ''
      gift_list.forEach((item) => {
        if (this.remark) {
          var remark = ''
          remark = item.freightDetail.supplierId + '_' + this.remark
          remarks += remark + '&&'
        }
      })
      remarks = remarks.substring(0, remarks.length - 2)
      console.log('备注', remarks)
      if (tipText != '') {
        this.$message({
          message: tipText + '暂无可选配送时间，不支持配送',
          type: 'warning'
        })
        return
      }
      if (text != '') {
        this.$message({
          message: text + '需要选择配送时间',
          type: 'warning'
        })
        return
      }
    //   if (dateText != '') {
    //     this.$message({
    //       message: dateText + '请选择期望发货日期',
    //       type: 'warning'
    //     })
    //     return
    //   }
      console.log(text)
      //临时修改，确保存在ids
      // if(!ids){
      //   list.forEach((item, index) => {
      //     ids += item.itemSkus[0].id + "_" + lb_detail.spuNoList[index] + ",";
      //   });
      // }
      deliveryTimes = deliveryTimes.substring(0, deliveryTimes.length - 1)
      ids = ids.substring(0, ids.length - 1)
      console.log('ids', ids)
      this.$confirm('是否确认创建订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loadingg = true
        var data = {
          userAddressUid: this.show_address.uid,
          festivalPackageUids: this.gift_details.festivalPackage.uid,
          clientPlatform: 2,
          itemSkuInfo: ids,
          skuSubGoodsIds: f_ids,
          remarks: remarks,
          deliveryTimes: deliveryTimes,
          festivalUid: this.user.festival.uid
        }
        let expectedShippingTimes = this.getDateDeliveryQuery()
        if (expectedShippingTimes) {
          data.expectedShippingTimes = expectedShippingTimes
        }
        console.log(data)
        var headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.user.token
        }
        this.$server.createFestivalPackageOrder(data, headers).then((res) => {
          console.log(res)
          this.loadingg = false
          if (res.code == 0) {
            sessionStorage.setItem('order_detail', JSON.stringify(res.data.order))
            this.$router.replace({
              path: '/order_pay'
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
      })
    },
    binddhs_cart() {
      var gift_list = this.gift_list
      console.log('礼包信息s', gift_list)
      var list = this.cart_list
      console.log('礼包信息s', list)
      var ids = ''
      var f_ids = ''
      var deliveryTimes = ''
      var text = ''
      var tipText = ''
      var festivalPackageUids = ''
      var dateText = ''
      list.forEach((itemss, indexss) => {
        if (!itemss.show) {
          return
        }
        festivalPackageUids += itemss.festivalPackage.uid + ','
        itemss.spuList.forEach((item, index) => {
          console.log(item)
          item.itemSkus.forEach((item1) => {
            gift_list.forEach((item2) => {
              item2.pinucOrderItemList.forEach((item3) => {
                if (item1.id == item3.skuId) {
                  item1.xz_time = item3.xz_time
                  console.log('选择的时间', item3.xz_time)
                  if (item3.xz_time) {
                    deliveryTimes += item3.xz_time + ','
                  } else {
                    deliveryTimes += ' ' + ','
                  }
                  if (item3.time_show == 1 && (item3.xz_time == '' || !item3.xz_time)) {
                    text += item3.skuName + ','
                  }
                  if (item3.time_show == 2) {
                    tipText += item3.skuName + ','
                  }
                  if (item3.date_show && !this.deliveryDataMap.get(item3.skuId)) {
                    dateText += item3.skuName + ','
                  }
                }
              })
            })
            if (item.show_skuid == 0) {
              ids += item1.id + '_' + itemss.spuNoList[index] + ','
            } else {
              if (item.show_skuid == item1.id) {
                ids += item1.id + '_' + itemss.spuNoList[index] + ','
              }
            }
          })
          if (item.subGoodss) {
            var subb = ''
            item.subGoodss.forEach((item1) => {
              if (item1.indexx >= 0 && item1.indexx != null && item1.sub_goods && item1.sub_goods.length > 0) {
                subb += item1.sub_goods[item1.indexx].id + '_'
              }
            })
            console.log(subb)
            subb = subb.substring(0, subb.length - 1)
            f_ids += subb + ','
          } else {
            f_ids += ' ' + ','
          }
        })
      })
      var remarks = ''
      gift_list.forEach((item) => {
        if (this.remark) {
          var remark = ''
          remark = item.freightDetail.supplierId + '_' + this.remark
          remarks += remark + '&&'
        }
      })
      remarks = remarks.substring(0, remarks.length - 2)
      console.log('备注', remarks)
      if (tipText != '') {
        this.$message({
          message: tipText + '暂无可选配送时间，不支持配送',
          type: 'warning'
        })
        return
      }
      if (text != '') {
        this.$message({
          message: text + '需要选择配送时间',
          type: 'warning'
        })
        return
      }
    //   if (dateText != '') {
    //     this.$message({
    //       message: dateText + '请选择期望发货日期',
    //       type: 'warning'
    //     })
    //     return
    //   }
      console.log(text)
      //临时修改，确保存在ids
      // if(!ids){
      //   list.forEach((item, index) => {
      //     ids += item.itemSkus[0].id + "_" + lb_detail.spuNoList[index] + ",";
      //   });
      // }
      deliveryTimes = deliveryTimes.substring(0, deliveryTimes.length - 1)
      festivalPackageUids = festivalPackageUids.substring(0, festivalPackageUids.length - 1)
      ids = ids.substring(0, ids.length - 1)
      console.log('ids', ids)
      this.$confirm('是否确认创建?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loadingg = true
        var data = {
          userAddressUid: this.show_address.uid,
          festivalPackageUids: festivalPackageUids,
          clientPlatform: 2,
          itemSkuInfo: ids,
          skuSubGoodsIds: f_ids,
          remarks: remarks,
          deliveryTimes: deliveryTimes,
          festivalUid: this.user.festival.uid
        }
        let expectedShippingTimes = this.getDateDeliveryQuery()
        if (expectedShippingTimes) {
          data.expectedShippingTimes = expectedShippingTimes
        }
        console.log(data)
        var headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.user.token
        }
        this.$server.createFestivalPackageOrder(data, headers).then((res) => {
          console.log(res)
          this.loadingg = false
          if (res.code == 0) {
            sessionStorage.setItem('order_detail', JSON.stringify(res.data.order))
            this.$router.replace({
              path: '/order_pay'
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
      })
    },
    bindaddTrustedDevice(uid) {
      //添加信用设备
      var that = this
      let fpPromise = FingerprintJS.load()
      fpPromise.then((fp) => fp.get()).then((result) => {
        console.log(result.visitorId)
        let data = {
          deviceId: result.visitorId,
          parentOrderUid: uid
        }
        that.$server.addTrustedDevice(data).then((res) => {
          localStorage.setItem('DeviceId', result.visitorId)
        })
      })
    },
    binddhs() {
      var lb_detail = this.gift_details
      var gift_list = this.gift_list
      console.log('礼包信息', this.gift_details)
      console.log('礼包信息s', gift_list)
      var list = this.gift_details.spuList
      var ids = ''
      var f_ids = ''
      var deliveryTimes = ''
      var text = ''
      var tipText = ''
      var dateText = ''
      console.log(list)
      list.forEach((item, index) => {
        console.log(item)
        item.itemSkus.forEach((item1) => {
          gift_list.forEach((item2) => {
            item2.pinucOrderItemList.forEach((item3) => {
              if (item1.id == item3.skuId) {
                item1.xz_time = item3.xz_time
                console.log('选择的时间', item3.xz_time)
                if (item3.xz_time) {
                  deliveryTimes += item3.xz_time + ','
                } else {
                  deliveryTimes += ' ' + ','
                }
                if (item3.time_show == 1 && (item3.xz_time == '' || !item3.xz_time)) {
                  text += item3.skuName + ','
                }
                if (item3.time_show == 2) {
                  tipText += item3.skuName + ','
                }
                if (item3.date_show && !this.deliveryDataMap.get(item3.skuId)) {
                  dateText += item3.skuName + ','
                }
              }
            })
          })
          if (item.show_skuid == 0) {
            ids += item1.id + '_' + lb_detail.spuNoList[index] + ','
          } else {
            if (item.show_skuid == item1.id) {
              ids += item1.id + '_' + lb_detail.spuNoList[index] + ','
            }
          }
        })
        if (item.subGoodss) {
          var subb = ''
          item.subGoodss.forEach((item1) => {
            if (item1.indexx >= 0 && item1.indexx != null && item1.sub_goods && item1.sub_goods.length > 0) {
              subb += item1.sub_goods[item1.indexx].id + '_'
            }
          })
          console.log(subb)
          subb = subb.substring(0, subb.length - 1)
          f_ids += subb + ','
        } else {
          f_ids += ' ' + ','
        }
      })
      var remarks = ''
      gift_list.forEach((item) => {
        if (this.remark) {
          var remark = ''
          remark = item.freightDetail.supplierId + '_' + this.remark
          remarks += remark + '&&'
        }
      })
      remarks = remarks.substring(0, remarks.length - 2)
      console.log('备注', remarks)
      if (tipText != '') {
        this.$message({
          message: tipText + '暂无可选配送时间，不支持配送',
          type: 'warning'
        })
        return
      }
      if (text != '') {
        this.$message({
          message: text + '需要选择配送时间',
          type: 'warning'
        })
        return
      }
    //   if (dateText != '') {
    //     this.$message({
    //       message: dateText + '请选择期望发货日期',
    //       type: 'warning'
    //     })
    //     return
    //   }
      console.log(text)
      //临时修改，确保存在ids
      // if(!ids){
      //   list.forEach((item, index) => {
      //     ids += item.itemSkus[0].id + "_" + lb_detail.spuNoList[index] + ",";
      //   });
      // }
      deliveryTimes = deliveryTimes.substring(0, deliveryTimes.length - 1)
      ids = ids.substring(0, ids.length - 1)
      console.log('ids', ids)
      this.$confirm('是否确认兑换礼包?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loadingg = true
        var data = {
          userAddressUid: this.show_address.uid,
          festivalPackageUid: this.gift_details.festivalPackage.uid,
          clientPlatform: 2,
          itemSkuInfo: ids,
          skuSubGoodsIds: f_ids,
          remarks: remarks,
          deliveryTimes: deliveryTimes,
          festivalUid: this.user.festival.uid
        }
        let expectedShippingTimes = this.getDateDeliveryQuery()
        if (expectedShippingTimes) {
          data.expectedShippingTimes = expectedShippingTimes
        }
        console.log(data)
        var headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.user.token
        }
        this.$server.confirmFestivalPackageOrder(data, headers).then((res) => {
          console.log(res)
          this.loadingg = false
          if (res.code == 0) {
            this.getUser()
            sessionStorage.setItem('address', JSON.stringify(this.show_address))
            this.$router.push({
              path: '/result',
              query: {
                id: res.data.default.uid,
                name: this.gift_details.festivalPackage.name
              }
            })
            this.bindaddTrustedDevice(res.data.default.uid)
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
      })
    },
    qr_address() {
      // var detail = sessionStorage.getItem("gift_details")
      console.log(this.gift_list)
      var list = this.gift_list
      var spuIds = ''
      var skuNames = ''
      list.forEach((item) => {
        item.pinucOrderItemList.forEach((item1) => {
          spuIds += item1.spuId + ','
          skuNames += item1.skuName + ','
        })
      })
      spuIds = spuIds.substring(0, spuIds.length - 1)
      skuNames = skuNames.substring(0, skuNames.length - 1)
      var data = {
        cityId: this.show_address ? this.show_address.cityId : 0,
        provinceId: this.show_address ? this.show_address.provinceId : 0,
        spuIds: spuIds,
        skuNames: skuNames
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.verifyItemRegion(data, headers).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.address_show = true
          this.ts_show = ''
        } else {
          this.address_show = false
          this.ts_show = res.msg
        }
      })
      /////////////////////////

      // console.log(this.show_address);
      // console.log(this.gift_details);
      // this.address_show = false;
      // var show_address = this.show_address;
      // var list = this.gift_details;
      // var numm = 0;
      // var ts_show = "";
      // list.spuList.forEach(item => {
      //   item.dq_show = false;
      //   var list = item.itemRegions;
      //   list.forEach(itemc => {
      //     if (
      //       show_address &&
      //       (show_address.cityId == itemc.id ||
      //         show_address.districtId == itemc.id ||
      //         show_address.provinceId == itemc.id ||
      //         show_address.townId == itemc.id ||
      //         itemc.id == 304446)
      //     ) {
      //       item.dq_show = true;
      //       numm++;
      //     }
      //   });
      //   // if (item.dq_show == false) {
      //   // 	console.log(item)
      //   // 	ts_show += item.itemAttrValue + ','
      //   // }
      // });
      // this.ts_show = ts_show;
      // console.log(numm);
      // if (numm >= list.spuList.length) {
      //   this.address_show = true;
      // }
    },
    binddelete(e) {
      this.$confirm('是否确认删除地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = {
          addressUid: e
        }
        var headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.user.token
        }
        this.$server.deleteaddress(data, headers).then((res) => {
          console.log(res)
          if (res.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'sussecc'
            })
            this.getaddress()
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
      })
    },
    bindxj() {
      this.bindcz()
      this.add_show = true
    },
    bindxiugai() {
      console.log(this.show_address)
      this.bindcz()
      this.datas = this.show_address
      this.datas.details = this.datas.detail
      this.datas.log_details = this.datas.detail
      this.datas.isDefault = this.show_address.defaultAddress
      this.isDefault = this.show_address.defaultAddress
      this.city_s = this.show_address.provinceId
      this.city_c = this.show_address.cityId
      this.city_q = this.show_address.districtId
      this.city_x = this.show_address.townId
      this.add_show = true
      console.log(this.datas)
      ///////////////////////////////////////////////////////////////
      var data = {
        parentId: this.show_address.provinceId
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.querydq(data, headers).then((res) => {
        console.log(res)
        var list = res.data.default
        this.city_list = list
        //						this.city_c= list[0]
      })
      var data = {
        parentId: this.show_address.cityId
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.querydq(data, headers).then((res) => {
        console.log(res)
        var list = res.data.default
        this.qy_list = list
        //						this.city_c= list[0]
      })
      var data = {
        parentId: this.show_address.districtId
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.querydq(data, headers).then((res) => {
        console.log(res)
        var list = res.data.default
        this.xz_list = list
        //						this.city_c= list[0]
      })
      //////////////////////////////////////////////////////////////////////
    },
    bc_address() {
      //    console.log(this.city_s, this.city_c, this.city_q, this.city_x);
      if (this.user.festival && this.user.festival.cardTestInfo) {
        let infos = this.user.festival.cardTestInfo.split('_')
        if (this.user.cardNo == infos[0]) {
          this.$confirm('当前登录为体验账号，仅作体验展示使用，暂不支持添加收货地址', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {})
          return
        }
      }
      if (!this.datas.consignee) {
        this.$message({
          message: '请输入姓名',
          type: 'warning'
        })
        return
      }
      if (!this.datas.mobile) {
        this.$message({
          message: '请输入手机号码',
          type: 'warning'
        })
        return
      }
      if (!this.city_c) {
        this.$message({
          message: '请选择所在地区',
          type: 'warning'
        })
        return
      }
      if (this.qy_list.length > 0 && !this.city_q) {
        this.$message({
          message: '请选择所在区',
          type: 'warning'
        })
        return
      }
      if (this.xz_list.length > 0 && !this.city_x) {
        this.$message({
          message: '请选择所在乡镇',
          type: 'warning'
        })
        return
      }
      if (!this.datas.detail) {
        this.$message({
          message: '请输入详细地址',
          type: 'warning'
        })
        return
      }
      // if (!this.datas.doorplate) {
      //   this.$message({
      //     message: "请输入门牌号",
      //     type: "warning"
      //   });
      //   return;
      // }
      this.datas.provinceId = this.city_s
      this.dq_list.forEach((item) => {
        if (item.id == this.city_s) {
          console.log(item)
          this.datas.province = item.name
        }
      })
      this.datas.cityId = this.city_c
      this.city_list.forEach((item) => {
        if (item.id == this.city_c) {
          this.datas.city = item.name
        }
      })
      this.datas.districtId = this.city_q
      this.qy_list.forEach((item) => {
        if (item.id == this.city_q) {
          this.datas.district = item.name
        }
      })
      this.datas.townId = this.city_x ? this.city_x : 0
      this.xz_list.forEach((item) => {
        if (item.id == this.city_x) {
          this.datas.town = item.name
        }
      })
      console.log(this.datas)
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.datas.isDefault = this.isDefault
      if (this.datas.uid) {
        this.datas.addressUid = this.datas.uid
        this.$server.updateaddress(this.datas, headers).then((res) => {
          console.log(res)
          if (res.code == 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.show_address = res.data.default
            this.add_show = false
            this.getaddress()
            this.city_list = []
            this.qy_list = []
            this.xz_list = []
            this.city_s = ''
            this.city_c = ''
            this.city_q = ''
            this.bindcz()
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        })
      } else {
        this.$server.createaddress(this.datas, headers).then((res) => {
          console.log(res)
          if (res.code == 0) {
            this.$message({
              message: '新建成功',
              type: 'success'
            })
            this.show_address = res.data.default
            this.add_show = false
            this.getaddress()
            this.city_s = ''
            this.city_c = ''
            this.city_q = ''
            this.bindcz()
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        })
      }
    },
    bindcz() {
      this.city_list = []
      this.qy_list = []
      this.xz_list = []
      this.searchResult = []
      this.city_s = ''
      this.isDefault = false
      this.datas = {
        consignee: '',
        mobile: '',
        province: '',
        city: '',
        district: '',
        town: '',
        provinceId: '',
        cityId: '',
        districtId: '',
        townId: '',
        detail: ''
        // isDefault:false
      }
    },
    //////
    queryRegions() {
      //查询地区
      var data = {
        parentId: '0'
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.querydq(data, headers).then((res) => {
        console.log(res)
        if (res.code == 0) {
          var list = res.data.default
          console.log('地区', list)
          this.dq_list = list
        } else {
          //							this.$Message.error(res.msg)
        }
      })
    },
    bindchangey(e) {
      console.log(e)
      this.city_x = ''
      this.xz_list = ''
      this.qy_list.forEach((item) => {
        if (item.id == e) {
          this.district = item
        }
      })
      var data = {
        parentId: e
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.querydq(data, headers).then((res) => {
        console.log(res)
        var list = res.data.default
        this.xz_list = list
        //						this.city_c= list[0]
      })
    },
    bindchangex(e) {
      console.log(e)
      this.xz_list.forEach((item) => {
        if (item.id == e) {
          this.town = item
        }
      })
    },
    bindchangeq(e) {
      this.city_q = ''
      this.city_x = ''
      //				this.qy_list=''
      this.xz_list = ''
      console.log(e)
      this.city_list.forEach((item) => {
        if (item.id == e) {
          this.city = item
        }
      })
      console.log(this.city)
      var data = {
        parentId: e
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.querydq(data, headers).then((res) => {
        console.log(res)
        var list = res.data.default
        this.qy_list = list
        //						this.city_c= list[0]
        // this.bindchangey(this.city_q)
      })
    },
    bindchanges(e) {
      this.city_c = ''
      this.city_q = ''
      this.city_x = ''
      this.city_list = ''
      this.qy_list = ''
      this.xz_list = ''
      console.log(e)
      this.dq_list.forEach((item) => {
        if (item.id == e) {
          this.province = item
        }
      })
      var data = {
        parentId: e
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.querydq(data, headers).then((res) => {
        console.log(res)
        var list = res.data.default
        this.city_list = list
        //						this.city_c= list[0]
      })
    },
    /////
    bindselect() {
      this.address_list.forEach((item) => {
        if (item.uid == this.add_index) {
          this.show_address = item
          this.getaddress()
        }
      })

      this.tpVisible = false
    },
    select_address(e) {
      this.add_index = e
      // this.qr_address();
    },
    bindduihuang() {
      this.$router.push({ path: '/result' })
    },
    getaddress(type) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      var show_address = localStorage.getItem('show_address')
      this.$server.queryaddress({}, headers).then((res) => {
        if (res.code == 0) {
          console.log('dizhi', res)
          var list = res.data.default
          this.address_list = list
          if (this.add_index == null) {
            this.show_address = list[0]
            this.add_index = list[0] ? list[0].uid : ''
          }

          list.forEach((item, index) => {
            if (item.defaultAddress) {
              if (this.add_index == null) {
                this.show_address = item
                this.add_index = item.uid
              }
            }
          })

          if (type == 1 && show_address) {
            console.log('1111111111111111111111111')
            this.show_address = JSON.parse(show_address)
            this.add_index = JSON.parse(show_address).uid
          }
          console.log('选择的地址', JSON.parse(show_address))
          console.log('选择的地址11', this.show_address)
          if (list.length > 0) {
            this.add_show = false
          } else {
            this.add_show = true
            this.tpVisible = false
          }
          console.log('this.cart_show', this.cart_show)
          if (this.cart_show) {
            this.gift_detail1()
          } else {
            this.gift_detail()
          }
        }
      })
    },
    gift_detail1() {
      console.log('购物车来的')
      var that = this
      this.loadingg = true
      var cart_list = localStorage.getItem('cart_list')
      var sp_list = cart_list ? JSON.parse(cart_list) : []
      this.cart_list = sp_list
      var add_d = {
        cityId: 304448,
        districtId: 304449,
        provinceId: 304447,
        townId: 0
      }
      var address = this.show_address ? this.show_address : add_d
      console.log(this.show_address)
      // var lb_detail = JSON.parse(detail);
      this.gift_details = sp_list[0]
      ///////////////
      // console.log('lb_detail',lb_detail);
      // var list = lb_detail.spuList;
      var ids = ''
      var f_ids = ''
      var needGifts = ''
      var num_list = []
      var all_price = 0
      sp_list.forEach((items) => {
        if (!items.show) {
          return
        }
        num_list = [...num_list, ...items.spuNoList]
        all_price += items.festivalPackage.standardPrice
        items.spuList.forEach((item) => {
          console.log(item.show_skuid, item.id)
          console.log(item.subGoodss)
          ids += item.show_skuid + ','
          // f_ids += " " + ",";
          needGifts += '0' + ','
          if (item.subGoodss) {
            var subb = ''
            item.subGoodss.forEach((item1) => {
              console.log(item1)
              if (item1.indexx >= 0 && item1.indexx != null && item1.sub_goods && item1.sub_goods.length > 0) {
                console.log(item1.indexx)
                subb += item1.sub_goods[item1.indexx].id + '_'
              }
            })
            console.log(subb)
            subb = subb.substring(0, subb.length - 1)
            f_ids += subb + ','
          } else {
            f_ids += ' ' + ','
          }
        })
      })
      this.all_price = all_price / 100
      ids = ids.substring(0, ids.length - 1)
      // f_ids = f_ids.substring(0, f_ids.length - 1);
      needGifts = needGifts.substring(0, needGifts.length - 1)
      var data = {
        skuIds: ids,
        skuPurchaseNos: num_list.toString(),
        skuSubGoodsIds: f_ids,
        needGifts: needGifts,
        districtId: address.districtId ? address.districtId : '0',
        townId: address.townId ? address.townId : '0',
        cityId: address.cityId ? address.cityId : '0',
        provinceId: address.provinceId ? address.provinceId : '0'
      }

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.previewItemOrder(data, headers).then(async (res) => {
        console.log(res, '--------------------------------------------------------------------=============')
        if (res.code != 0) {
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {})
          return
        }
        var listss = res.data.default
        let tmpplandatas = []
        let skuShippingDateId = [] //日期发货id集合
        var freight = 0
        var cid = address.cityId ? address.cityId : '0'
        if (address.province == '北京' || address.province == '天津' || address.province == '上海' || address.province == '重庆') {
          cid = address.provinceId
        }
        listss.forEach((lili, indexff) => {
          freight += lili.freight
          lili.pinucOrderItemList.forEach((item, index) => {
            if (item.skuId == 0) {
              lili.pinucOrderItemList.splice(index, 1)
              return
            }
            skuShippingDateId.push(item.skuId)
          })
        })
        //日期发货时间
        let skuShippingDateData = {} //
        if (skuShippingDateId.length) {
          skuShippingDateData = await this.setDateSkuList(skuShippingDateId, cid, headers).catch((err) => {})
        }
        console.log('skuShippingDateData', skuShippingDateData)
        listss.forEach((lili, indexff) => {
          freight += lili.freight
          lili.pinucOrderItemList.forEach((item, index) => {
            if (item.skuId == 0) {
              lili.pinucOrderItemList.splice(index, 1)
              return
            }
            item.attrJson = JSON.parse(item.attrJson)
            item.itemSkuJson = JSON.parse(item.itemSkuJson)
            item.subGoodsJson = JSON.parse(item.subGoodsJson)
            //日期发货时间
            // this.$set(item, 'dateSkuList', ['2024-09-25', '2024-09-26'])
            if (skuShippingDateData && skuShippingDateData[item.skuId]) {
              let dateSkuList = skuShippingDateData[item.skuId]
              this.$set(item, 'date_show', true)
              this.$set(item, 'dateSkuList', dateSkuList)
            } else {
              this.$set(item, 'date_show', false)
            }
            var dtdt = {
              skuId: item.skuId,
              cityId: cid
            }
            /** 查询sku配送日期/期望发货时间  */
            // export function querySkuShippingDate(params) {
            //   return sendRequest('/itemorder/query-sku-shipping-date', params)
            // }
            // that.$server.querySkuShippingDate(dateSku, headers).then((rea) => {
            //   console.log('查询sku配送日期/期望发货时间', rea) // if(rea.data.default.status==1){
            //   let itemDat = rea.data.data[0]
            //   //   rea.data.data.map((item) => {
            //   if (itemDat.type == 2 && itemDat.dateList && itemDat.dateList.length) {
            //     let dateList = itemDat.dateList.map((dates) => dates.date)
            //     that.$set(this.gift_list[indexff].pinucOrderItemList[index], 'date_show', true)
            //     that.$set(this.gift_list[indexff].pinucOrderItemList[index], 'dateSkuList', dateList)
            //   } else {
            //     that.$set(this.gift_list[indexff].pinucOrderItemList[index], 'date_show', false)
            //   }
            //   //   })
            //   // item.time_show=status==1? true : false
            // })
            that.$server.getItemDeliveryDesc(dtdt, headers).then((rea) => {
              console.log('查询是不支持选择配送时间', rea) // if(rea.data.default.status==1){
              var status = rea.data.default.status
              // item.time_show=status==1? true : false
              that.$set(this.gift_list[indexff].pinucOrderItemList[index], 'time_show', status)
            })
          })
        })
        this.loadingg = false
        this.freight = freight / 100
        this.gift_list = listss
        this.qr_address()
        this.bindkc(data)
        console.log(listss)
      })
    },
    bindkc(data) {
      var gift_list = this.gift_list
      var kc_num = 0
      var add_d = {
        cityId: 304448,
        districtId: 304449,
        provinceId: 304447,
        townId: 0
      }
      var ids = ''
      var nums = ''
      gift_list.forEach((item) => {
        item.pinucOrderItemList.forEach((item1) => {
          ids += item1.skuId + ','
          nums += item1.purchaseNumber + ','
        })
      })
      ids = ids.substring(0, ids.length - 1)
      nums = nums.substring(0, nums.length - 1)
      var address = this.show_address ? this.show_address : add_d
      var data = {
        skuIds: ids,
        skuPurchaseNos: nums,
        districtId: address.districtId ? address.districtId : '0',
        townId: address.townId ? address.townId : '0',
        cityId: address.cityId ? address.cityId : '0',
        provinceId: address.provinceId ? address.provinceId : '0'
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.verifyItemStock(data, headers).then((res) => {
        console.log('查询库存', res)
        if (res.code == 0) {
          var k_list = res.data.default

          gift_list.forEach((item, index) => {
            k_list.forEach((item1) => {
              item.pinucOrderItemList.forEach((item2, index2) => {
                if (item1.skuId == item2.skuId) {
                  item2.stockStae = item1.stockStae
                  this.$set(this.gift_list[index].pinucOrderItemList[index2], 'stockStae', item1.stockStae)
                }
              })
              if (item1.stockStae != 1) {
                kc_num += 1
              }
            })
          })
          console.log(gift_list)
        }
      })
      this.kc_num = kc_num
    },
    gift_detail() {
      console.log('商品详情来的')
      this.loadingg = true
      var that = this
      var detail = sessionStorage.getItem('gift_details')
      var add_d = {
        cityId: 304448,
        districtId: 304449,
        provinceId: 304447,
        townId: 0
      }
      var address = this.show_address ? this.show_address : add_d
      console.log(this.show_address)
      var lb_detail = JSON.parse(detail)
      this.gift_details = lb_detail
      ///////////////
      console.log('lb_detail', lb_detail)
      var list = lb_detail.spuList
      var ids = ''
      var f_ids = ''
      var needGifts = ''
      list.forEach((item) => {
        console.log(item.show_skuid, item.id)
        console.log(item.subGoodss)
        ids += item.show_skuid + ','
        // f_ids += " " + ",";
        needGifts += '0' + ','
        if (item.subGoodss) {
          var subb = ''
          item.subGoodss.forEach((item1) => {
            console.log(item1)
            if (item1.indexx >= 0 && item1.indexx != null && item1.sub_goods && item1.sub_goods.length > 0) {
              console.log(item1.indexx)
              subb += item1.sub_goods[item1.indexx].id + '_'
            }
          })
          console.log(subb)
          subb = subb.substring(0, subb.length - 1)
          f_ids += subb + ','
        } else {
          f_ids += ' ' + ','
        }
      })
      ids = ids.substring(0, ids.length - 1)
      // f_ids = f_ids.substring(0, f_ids.length - 1);
      needGifts = needGifts.substring(0, needGifts.length - 1)
      var data = {
        skuIds: ids,
        skuPurchaseNos: lb_detail.spuNoList.toString(),
        skuSubGoodsIds: f_ids,
        needGifts: needGifts,
        districtId: address.districtId ? address.districtId : '0',
        townId: address.townId ? address.townId : '0',
        cityId: address.cityId ? address.cityId : '0',
        provinceId: address.provinceId ? address.provinceId : '0'
      }

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.previewItemOrder(data, headers).then(async (res) => {
        console.log('1713', res)
        if (res.code != 0) {
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {})
          return
        }
        var listss = res.data.default
        let skuShippingDateId = [] //日期发货id集合
        let tmpplandatas = []
        var freight = 0
        var cid = address.cityId ? address.cityId : '0'
        if (address.province == '北京' || address.province == '天津' || address.province == '上海' || address.province == '重庆') {
          cid = address.provinceId
        }
        listss.forEach((lili, indexff) => {
          freight += lili.freight
          lili.pinucOrderItemList.forEach((item, index) => {
            if (item.skuId == 0) {
              lili.pinucOrderItemList.splice(index, 1)
              return
            }
            skuShippingDateId.push(item.skuId)
          })
        })
        //日期发货时间
        let skuShippingDateData = {} //
        if (skuShippingDateId.length) {
          skuShippingDateData = await this.setDateSkuList(skuShippingDateId, cid, headers).catch((err) => {})
        }
        console.log('skuShippingDateData', skuShippingDateData)
        listss.forEach((lili, indexff) => {
          freight += lili.freight
          lili.pinucOrderItemList.forEach((item, index) => {
            if (item.skuId == 0) {
              lili.pinucOrderItemList.splice(index, 1)
              return
            }
            item.attrJson = JSON.parse(item.attrJson)
            item.itemSkuJson = JSON.parse(item.itemSkuJson)
            item.subGoodsJson = JSON.parse(item.subGoodsJson)
            //日期发货时间
            // this.$set(item, 'dateSkuList', ['2024-09-25', '2024-09-26'])
            if (skuShippingDateData && skuShippingDateData[item.skuId]) {
              let dateSkuList = skuShippingDateData[item.skuId]
              this.$set(item, 'date_show', true)
              this.$set(item, 'dateSkuList', dateSkuList)
            } else {
              this.$set(item, 'date_show', false)
            }
            var dtdt = {
              skuId: item.skuId,
              cityId: cid
            }
            that.$server.getItemDeliveryDesc(dtdt, headers).then((rea) => {
              console.log('查询是不支持选择配送时间', rea) // if(rea.data.default.status==1){
              var status = rea.data.default.status
              // item.time_show=status==1? true : false
              that.$set(this.gift_list[indexff].pinucOrderItemList[index], 'time_show', status == 1 ? true : false)
            })
            // this.bindtimess(item,indexs,index)
            // tmpplandatas.push(new Promise(function(resolve, reject) {
            //   console.log('0000000')
            //   that.$server.getItemDeliveryDesc(dtdt, headers).then(rea => {
            //     console.log('查询是不支持选择配送时间', rea); // if(rea.data.default.status==1){
            //     var datar = {
            //       skuId: item.skuId,
            //       status: rea.data.default.status
            //     };
            //     resolve(datar);
            //   });
            // }));
          })
          // Promise.all(tmpplandatas).then(res => {
          // 		console.log(res);
          // 		lili.pinucOrderItemList.forEach((item3, index) => {
          // 			res.forEach(item4 => {
          //         console.log(item3,item4)
          // 				if (item3.skuId == item4.skuId) {
          //             var yuyu = item4.status == 1 ? true : false
          //           // that.$set(item3,time_show,yuyu)
          //           // console.log('this.gift_list',this.gift_list)
          //           item3.time_show = item4.status == 1 ? true : false;
          //           // that.$set(item3,time_show,yuyu)

          // 				}
          // 			});
          //     });
          //      this.gift_list = listss;
          //     // that.$set(gift_list[gift_list],pinucOrderItemList,lili.pinucOrderItemList)

          // 	}).catch(error => {
          // 		console.log("还有没执行完的"); // 打开的是 'failed'
          // 	});
        })
        this.loadingg = false
        this.freight = freight / 100
        this.gift_list = listss
        this.bindkc(data)
        this.qr_address()
        console.log(listss)
      })
    },
    //处理发货日期
    setDateSkuList(skuShippingDateId, cid, headers) {
      return new Promise((resolve, reject) => {
        let skuShippingDateData = {}
        this.$server
          .querySkuShippingDate({ regionId: cid, skuIds: skuShippingDateId.join(',') }, headers)
          .then((res) => {
            if (res.code == 0) {
              if (res.data && res.data.data && res.data.data.length) {
                res.data.data.forEach((item) => {
                  if (item.type == 2 && item.dateList && item.dateList.length) {
                    skuShippingDateData[item.skuId] = item.dateList.map((dates) => dates.date)
                  }
                })
              }
              resolve(skuShippingDateData)
            } else {
              resolve({})
            }
          })
          .catch((err) => {
            resolve({})
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tk_box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  .add_kj {
    width: 420px;
    height: 320px;
    background: white;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    .ggbb {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 5px;
      right: 5px;
    }
    .add_kj_center1 {
      overflow-y: auto;
      height: 160px;
      padding: 0 32px;
      margin-top: 10px;
      .ybk_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        span {
          font-size: 16px;
          color: #333333;
        }
        div {
          i {
            display: inline-block;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #e6e6e6;
          }
        }
      }
    }
    .kj_bottom {
      width: 100%;
      position: absolute;
      box-sizing: border-box;
      background: white;
      // bottom:0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 52px;
      span {
        font-size: 12px;
        cursor: pointer;
        width: 72px;
        height: 32px;
        display: inline-block;
        border: 1px solid #e8e8e8;
        line-height: 32px;
        text-align: center;
      }
      span:nth-child(1) {
        background: #f3a251;
        color: white;
        margin-left: 15px;
        margin-right: 16px;
      }
    }
    .add_kj_center {
      .center_box {
        margin-bottom: 16px;
        input {
          height: 32px;
          padding: 0 16px;
          width: 240px;
          margin-left: 16px;
          outline: none;
          border: 1px solid #e6e6e6;
        }
      }
    }
    .add_kj_nav {
      width: 270px;
      height: 32px;
      margin: 24px auto;
      .add_nav_active {
        background: #fff4eb !important;
        border-color: #fac593;
        color: #ee8f36;
      }
      span {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        width: 90px;
        border: 1px solid #e6e6e6;
      }
    }
    .add_kj_top {
      height: 40px;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #e6e6e6;
      img {
        height: 20px;
        width: 20px;
        cursor: pointer;
      }
    }
  }
  .bj {
    height: 100%;
    width: 100%;
    background: #000000;
    opacity: 0.5;
  }
}
.tk_box {
  text-align: center;
  #qrCode {
    width: 49%;
    text-align: center;
    margin: 20px auto;
  }
  .an {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    span {
      display: inline-block;
      height: 30px;
      width: 90px;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
      border: 1px solid white;
      border-radius: 50px;
      font-size: 12px;
    }
    span:nth-child(1) {
      border: 1px solid #e6e6e6;
      background: white;
      margin-right: 24px;
    }
    span:nth-child(2) {
      margin-left: 5px;
      border-color: #f14a61;
      background: white;
      color: #f14a61;
    }
  }
}
.k_boxs {
  border: 1px solid #f3a251 !important;
  background: #fff7f0;
}
.k_boxs .k_num {
  color: #f3a251 !important;
}
.k_boxs .k_bl {
  border-color: #f3a251;
}

.box_x {
  display: flex;
  align-items: center;
  margin-left: 24px;
  margin-bottom: 24px;
  cursor: pointer;
}
.add_k {
  width: 100px;
  height: 32px;
  border: 1px solid #e6e6e6;
  display: flex;
  padding: 0 10px;
  align-items: center;
  margin-right: 24px;
  justify-content: space-around;
}
.k_big {
  display: flex;
  min-height: 170px !important;
  align-items: center;
  flex-wrap: wrap;
  padding: 24px !important;
  padding-bottom: 0 !important;
}
.k_box {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-right: 24px;
  margin-bottom: 24px;
}
.k_box:nth-child(4n + 4) {
  margin-right: 0;
}
.k_bl {
  display: flex;
  padding: 10px 0;
  margin-bottom: 14px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
}
.t_active {
  color: #f3a251;
  border: 1px solid #f3a251 !important;
}
.xzrq {
  display: flex;
}
.sj_box {
  display: inline-block;
  padding: 2px 5px;
  border: 1px solid #e6e6e6;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
.binddh {
  opacity: 0.6;
}
.xiugai {
  height: 24px;
  width: 60px;
  text-align: center;
  line-height: 24px;
  border: 1px solid #f3a251;
  color: #f3a251;
  display: inline-block;
  cursor: pointer;
  margin-left: 20px;
}
.dz_top_active {
  border-color: #f3a251 !important;
  background: url('../../assets/img/dz_xz.png') no-repeat right bottom;
}
.dz_box {
  min-height: 87px;
  cursor: pointer;

  border: 1px solid #e6e6e6;
  padding: 14px 16px;
  margin-bottom: 16px;
  .dz_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.add_rights {
  padding-left: 12px;
  display: flex;
  flex-direction: column;
}
.new_adds {
  width: 144px;
  height: 42px;
  display: inline-block;
  text-align: center;
  line-height: 42px;
  cursor: pointer;
}
.new_add {
  width: 144px;
  height: 42px;
  border: 1px solid rgba(232, 232, 232, 1);
  display: inline-block;
  text-align: center;
  line-height: 42px;
  cursor: pointer;
}
.address_bottom {
  margin-top: 30px;
}
.lists {
  min-height: 50px;
  border: 1px solid #e6e6e6;
  .rights {
    width: 200px;
    text-align: center;
  }
  .list_bottom {
    padding: 0 24px;
    min-height: 200px;
    .l_boxs:last-child {
      .l_box:last-child {
        border: none;
      }
    }

    .l_box {
      display: flex;
      align-items: center;
      padding: 24px 0;
      border-bottom: 1px dotted #cccccc;
    }
  }
  .list_top {
    display: flex;
    color: #909199;
    background: #f5f5f5;
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
  }
}
.select {
  width: 145px;
  height: 32px;
  margin-right: 24px;
}
.address_text {
  height: 247px;
  width: 100%;
  padding: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    width: 421px;
    height: 100%;
    border-left: 1px dotted #cccccc;
    padding-left: 32px;
    .aniu {
      display: flex;
      align-items: center;
    }
    .ljdhs {
      height: 50px;
      width: 186px;
      display: inline-block;
      line-height: 50px;
      margin-left: 10px;
      cursor: pointer;
      text-align: center;
      color: #f3a251;
      border: 1px solid;
      background: #fffaf6;
    }
    .ljdh {
      height: 50px;
      cursor: pointer;
      width: 186px;
      background: #f3a251;
      display: inline-block;
      line-height: 50px;
      text-align: center;
      color: white;
    }
  }
  .left {
    height: 100%;
    width: 738px;
    .boxx11 {
      display: flex;
      justify-content: space-between;
    }
    .boxx {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      .boxx1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 47%;
      }
    }
  }
}
.address_top {
  border: 1px solid #e6e6e6;
  margin-top: 32px;
  height: 291px;
  width: 100%;
  .title {
    height: 44px;
    width: 100%;
    background: #f5f5f5;
    color: #909199;
    font-size: 16px;
    line-height: 44px;
    padding-left: 22px;
  }
}
.address_big {
  min-height: 87vh;
  border-top: 1px solid #e4e5ed;
  padding-bottom: 50px;
}
.clear_date {
  width: 12px;
  height: 12px;
  margin-left: 3px;
}
</style>
